import React from 'react';
import { FieldArray } from 'redux-form';
import { useTranslations } from '@lang';
import { SectionWrapper } from '@common/components/BookingForms/Section';
import { AddExistingGuests, NotesField, Spinner } from '@common/components';
import { GuestField } from '@common/components/BookingForms';
import { NumberOfGuests } from './NumberOfGuests';

export const AddGuestsForm = ({
  hasEnoughQuantity,
  selectedGuests,
  minimumGuests,
  spaEntity,
  maximumGuests,
  guest,
  existingGuests,
  showGenderNeutral,
  typeName,
  isItemFetching,
  fieldChange,
}) => {
  const { t } = useTranslations();
  const { genderSpecific } = spaEntity;
  return (
    hasEnoughQuantity && (
      <>
        <SectionWrapper>
          <Spinner isActive={isItemFetching} isLocal />
          <NumberOfGuests
            hasEnoughQuantity={hasEnoughQuantity}
            minimumGuests={minimumGuests}
            maximumGuests={maximumGuests}
            typeName={typeName}
          />
          <FieldArray
            name="guests"
            component={AddExistingGuests}
            selectedGuests={selectedGuests}
            existingGuests={existingGuests}
            isGenderSpecific={genderSpecific}
            minimumGuests={minimumGuests}
            maximumGuests={maximumGuests}
            guest={guest}
            withTopMargin
          />
          <FieldArray
            name="guests"
            component={GuestField}
            maximumGuests={maximumGuests}
            minimumGuests={minimumGuests}
            isGenderSpecific={genderSpecific}
            showGenderNeutral={showGenderNeutral}
            fieldChange={fieldChange}
          />
        </SectionWrapper>
        <NotesField placeholder={t('booking.additionnalNotesPlaceholder')} />
      </>
    )
  );
};
